import { render, staticRenderFns } from "./dictionaryItem.vue?vue&type=template&id=35f3264c&scoped=true&"
import script from "./dictionaryItem.vue?vue&type=script&lang=js&"
export * from "./dictionaryItem.vue?vue&type=script&lang=js&"
import style0 from "./dictionaryItem.vue?vue&type=style&index=0&id=35f3264c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f3264c",
  null
  
)

export default component.exports